<!-- header component -->
<div class="header">
    <h1 *ngIf="this.headerText !== '' && this.headerText !== undefined">{{this.headerText}}</h1>
    <img *ngIf="this.headerText === '' || this.headerText === undefined" src="../../../assets/images/Now-Account_with_Mark_2.png" alt="NowAccount logo and name"/>
</div>
